<template>
  <div>
    <!-- If mode is 'list', show a simple list -->
    <div v-if="mode === 'list'">
      <v-list dense>
        <v-list-item
          v-for="(item, index) in catValueListArray(catName)"
          :key="index"
        >
          <v-list-item-content>
              {{ "{" + item + "}" }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <!-- Otherwise show v-autocomplete -->
    <v-autocomplete
      v-else
      v-model="listLocal"
      required
      :hint="`${listLocal}`"
      :label="label"
      :items="catValueListArray(catName)"
      item-value="node.valName"
      item-text="node.valDesc"
      sort
      :dark="darkMode"
      clearable
      dense
      clear-icon="fa-times"
      :multiple="multiList"
      small-chips
      :outlined="outlined"
      open-on-clear
      :color="color"
      class="cat_val_autocomplete"
    />
  </div>
</template>

<script>
import { getCatValues } from "../../mixins/getCatValues.js";
import { validation } from "../../mixins/validationMixin.js";

export default {
  props: {
    label: {
      type: String,
      default: () => "",
      required: true
    },
    catName: {
      type: String,
      default: () => "",
      required: true
    },
    parentValList: {
      default: () => []
    },
    multiList: {
      type: Boolean,
      default: () => false
    },
    color: {
      type: String,
      default: () => "light-blue darken-4"
    },
    outlined: {
      type: Boolean,
      default: () => false
    },
    darkMode: {
      type: Boolean,
      default: () => false
    },
    mode: {             // ✅ new prop added
      type: String,
      default: () => "autocomplete"
    }
  },
  mixins: [getCatValues, validation],
  model: {
    prop: "parentValList",
    event: "parentValListChange"
  },
  computed: {
    listLocal: {
      get: function() {
        return this.parentValList;
      },
      set: function(value) {
        this.$emit("parentValListChange", value);
      }
    }
  }
};
</script>

<style lang="scss">
.cat_val_autocomplete {
  padding-top: 0 !important;
  .v-text-field__details {
    display: none;
  }
  .v-input__slot {
    margin-bottom: 0 !important;
  }
}
</style>
